import { DRIVETRAINS, MOTION_TEXT } from "@/rc/drivetrains";
import { ChoiceCard } from "./ChoiceCard";
import { RobotDiagram } from "./RobotDiagram";

export const DrivetrainStep = ({ value, onPick }) => (
  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" role="radiogroup" aria-label="Drivetrain" data-testid="rc-drivetrain-step">
    {DRIVETRAINS.map((dt) => (
      <ChoiceCard key={dt.id} selected={dt.id === value} onClick={() => onPick(dt.id)} testId={`rc-drivetrain-${dt.id}`}>
        <div className="grid-bg flex items-center justify-center rounded-xl bg-muted/40 p-5">
          <RobotDiagram dt={dt} className="h-32 w-32" />
        </div>
        <div className="mt-3 flex items-start justify-between gap-2">
          <p className="font-display text-base font-bold leading-tight">{dt.name}</p>
          <span className="shrink-0 rounded-full bg-secondary px-2.5 py-0.5 text-xs font-semibold text-secondary-foreground">{dt.motors.length} motors</span>
        </div>
        <p className="mt-0.5 text-sm text-muted-foreground">{dt.subtitle}</p>
        <p className="mt-2 text-xs font-medium text-[hsl(var(--rc-hot))]">{MOTION_TEXT[dt.anim]}</p>
      </ChoiceCard>
    ))}
  </div>
);
